export default "__VITE_ASSET__g8Nh$D4y__"